import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import deepEqual from 'deep-equal'
import { connect } from 'react-redux'
import deepcopy from 'deepcopy'
import { DragSource, DropTarget } from 'react-dnd';
import { ItemTypes } from './Constants';
import AllAddonListItem from './AllAddonListItem'
import ReactSelect from 'react-select'


class AllAddonList extends Component {

  constructor(props) {
    super(props);

    var addonsList = [];
    for(var key in addonsJSON){
      
      addonsList.push(addonsJSON[key]);
    }
    
    var newAddonsList = deepcopy(addonsList);
    
    this.state = {
      addons: newAddonsList,
      categories: addonCats,
      activeCat: 'All'
    };
  }

  getCategories(){
    return this.state.categories.map(category => {
      return {
        value: category.name,
        label: category.name+' ('+category.count+')'
      }
    })
  }

  changeCategory(e){
    const { addons } = this.state;

    var filteredAddons = addons.map(function(addon){
          if (addon.category == e.value || e.value == 'All') {
            addon.visibility = true;
          }else{
            addon.visibility = false;
          }
          return addon;
        });
    this.setState({
      activeCat: e.value,
      addons: filteredAddons
    })
  }

  searchChangeHandle() {
    
    const { addons, activeCat } = this.state;
    const item = this.refs.searchItem.value;

    var resultAddons = addons.map(function(addon){
      if ( addon.title.toLowerCase().indexOf(item.toLowerCase()) !== -1) {
        addon.visibility = true;
      } else {
        addon.visibility = false;
      }
      return addon;
    });

    this.setState({
      activeCat: 'All',
      addons:resultAddons
    });
  }

  render() {
      return(
        <div className="sp-pagebuilder-addons-list-sidebar">
            <div className="sp-pagebuilder-category">
            <ReactSelect
              value={this.state.activeCat}
              clearable={false}
              options={this.getCategories()}
              onChange={this.changeCategory.bind(this)}
              />
              <div className="sp-pagebuilder-addons-search">
                <input
                  type="text"
                  ref="searchItem"
                  placeholder="Search"
                  onChange={this.searchChangeHandle.bind(this)}
                  />
                  <i className="fa fa-search"></i>
              </div>
              
            </div>
            <ul className="clearfix">
                {this.state.addons.map( ( addon,index )=>
                  addon.visibility != false &&
                <li key={index}>
                    <AllAddonListItem addon={addon} />
                </li>
                )}
            </ul>
        </div>
      )
  }
}



export default AllAddonList;


// WEBPACK FOOTER //
// ./src/components/AllAddonList.js